<div class="w-full bg-transparent flex flex-wrap justify-end items-center gap-6 py-2 px-2">
  <div class="flex items-center gap-3 text-sm text-[#333333]">
    <span>Rows per page</span>
    <div class="relative">
      <select [(ngModel)]="itemsPerPage" (ngModelChange)="navigateToPage(1)"
        class="appearance-none text-primary text-sm font-semibold bg-transparent border-b-2 border-primary focus:outline-none cursor-pointer pr-5 pb-1">
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="30">30</option>
        <option value="40">40</option>
        <option value="50">50</option>
      </select>
      <div class="absolute inset-y-0 right-0 flex items-center pointer-events-none">
        <i class="bx bx-chevron-down text-primary text-base"></i>
      </div>
    </div>
  </div>

  <span class="text-sm text-[#333333]">{{ showingFrom }}-{{ showingTo }} of {{ totalItems }}</span>

  <div class="flex items-center gap-1">
    <button (click)="handlePrevClick()" [disabled]="currentPage === 1"
      class="w-8 h-8 flex items-center justify-center rounded hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
      <i class="bx bx-chevron-left text-xl text-[#555]"></i>
    </button>
    <button (click)="handleNextClick()" [disabled]="showingTo >= totalItems"
      class="w-8 h-8 flex items-center justify-center rounded hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
      <i class="bx bx-chevron-right text-xl text-[#555]"></i>
    </button>
  </div>
</div>
